import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from './modalDataService'
import * as validationService from "./validationService";

function ApiPasswordField({ apiPassword, anotherSectionActive, error }) {

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('apiPassword');
            onChange('');
        } else {
            validationService.validateNotEmpty(apiPassword, 'apiPassword');
        }
        return () => validationService.cleanValidation('apiPassword');
    }, [apiPassword, anotherSectionActive])

    const onChange = (value) => modalDataService.changeApiPassword(value)

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="username">Password</label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="username"
                    type="password"
                    value={apiPassword}
                    placeholder="••••••••"
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ApiPasswordField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    const anotherSectionActive = !!addDeviceModal.apiKey; //|| !!addDeviceModal.apiUrl;
    return {
        apiPassword: addDeviceModal.apiPassword || '',
        error: validation.apiPassword,
        anotherSectionActive
    }
}

export default connect(mapStateToProps)(ApiPasswordField);
